import { ActivityIndicator, ProgressBar } from "react-native-paper";
import TouchableOpacity from "../TouchableOpacity/TouchableOpacity";
import { Props } from "./model";
import { StyledCodeText, StyledCodeWrapper, StyledContainer, StyledSpinnerWrapper, StyledText } from "./styled";

/**
 * Returns the styling for a progress bar based on the device type.
 *
 * @param {boolean} isMobile - Indicates if the device is a mobile device.
 * @returns {object} - Style object with borderRadius, height, width, and backgroundColor.
 */
const progressBarSize = (isMobile: boolean) => {
	if (isMobile) {
		return { borderRadius: 4, height: " 0.31738rem", width: "16.875rem", backgroundColor: "#002E11" };
	}
	return { borderRadius: 4, height: 16, width: 300, backgroundColor: "#002E11" };
};

const GradientCodeComponent = (props: Props) => {
	const counter = parseFloat(props.counter.toString()).toFixed(2);

	return (
		<>
			{!props?.hideButton ? (
				<TouchableOpacity onPress={props.onPress} disabled={props.disabled}>
					{/* @ts-ignores */}
					<StyledContainer>
						{/* @ts-ignores */}
						<StyledText disabled={props.disabled}>{props.title}</StyledText>
					</StyledContainer>
				</TouchableOpacity>
			) : (
				// @ts-ignores
				<StyledCodeWrapper isMobile={props.isMobile}>
					{!props.title ? (
						// @ts-ignores
						<StyledSpinnerWrapper>
							<ActivityIndicator size={"large"} color={"white"} />
						</StyledSpinnerWrapper>
					) : (
						<></>
					)}
					{/* @ts-ignores */}
					{props.title ? <StyledCodeText>{props.title}</StyledCodeText> : <></>}
					<ProgressBar progress={parseFloat(counter) ?? 0} color={"#008131"} style={progressBarSize(props?.isMobile)} />
				</StyledCodeWrapper>
			)}
		</>
	);
};

export default GradientCodeComponent;
